module.exports = __webpack_public_path__ + "media/bg/bg-5-29123125.jpg";